var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 68,
    height: 68,
    rx: 8,
    fill: "#4EB4E7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5631_3992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4443 70.3462H5.55544L25.111 41.0627H42.8888L62.4443 70.3462Z",
    fill: "#696B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1104 70.3462H10.8881L28.6659 41.0627H39.3326L57.1104 70.3462Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7764 70.3462H16.2208L32.2208 41.0627H35.7764L51.7764 70.3462Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1097 68.3334C17.1097 68.687 17.2923 69.0262 17.6174 69.2762C17.9424 69.5263 18.3833 69.6667 18.843 69.6667H50.043C50.5027 69.6667 50.9436 69.5263 51.2687 69.2762C51.5937 69.0262 51.7764 68.687 51.7764 68.3334C51.7764 67.9798 51.5937 67.6407 51.2687 67.3906C50.9436 67.1406 50.5027 67.0001 50.043 67.0001H18.843C18.3833 67.0001 17.9424 67.1406 17.6174 67.3906C17.2923 67.6407 17.1097 67.9798 17.1097 68.3334ZM20.5764 63.0001C20.5764 63.3537 20.759 63.6928 21.084 63.9429C21.4091 64.1929 21.85 64.3334 22.3097 64.3334H46.5764C47.0361 64.3334 47.477 64.1929 47.802 63.9429C48.1271 63.6928 48.3097 63.3537 48.3097 63.0001C48.3097 62.6465 48.1271 62.3073 47.802 62.0573C47.477 61.8072 47.0361 61.6667 46.5764 61.6667H22.3097C21.85 61.6667 21.4091 61.8072 21.084 62.0573C20.759 62.3073 20.5764 62.6465 20.5764 63.0001Z",
    fill: "#B5B7BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8645 51.9149L25.1108 41.0627H42.8885L50.1348 51.9149C46.7765 56.2505 41.605 60.0091 33.9997 60.0091C26.3961 60.0091 21.221 56.2488 17.8645 51.9149Z",
    fill: "#37B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0007 8.33374C50.0007 8.33374 55.334 13.5014 55.334 23.8368V37.6172C55.334 41.0606 50.0007 56.5653 34.0007 56.5653C18.0007 56.5653 12.6673 41.0606 12.6673 37.6172V23.8368C12.6673 13.5014 18.0007 8.33374 34.0007 8.33374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7764 27.2805C51.7764 11.7775 43.8173 10.0549 33.9986 10.0549C24.1799 10.0549 16.2208 11.7775 16.2208 27.2805C16.2208 37.6158 24.1799 46.2286 33.9986 46.2286C43.8173 46.2269 51.7764 37.6158 51.7764 27.2805Z",
    fill: "#0183BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0003 46.2287C31.0812 46.2287 28.3381 45.4535 25.9061 44.1134C27.2981 42.3185 30.3914 41.0627 34.0003 41.0627C37.6092 41.0627 40.7008 42.3185 42.0928 44.1151C39.6643 45.4535 36.9177 46.2287 34.0003 46.2287Z",
    fill: "#37B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2231 16.9432V25.4957C26.0222 25.0961 21.5564 22.7034 21.5564 21.2531V18.3833C21.5564 17.0207 28.12 16.9398 32.2231 16.9432ZM35.7786 16.9432C39.8818 16.9398 46.4453 17.019 46.4453 18.3833V21.2548C46.4453 22.7052 41.9795 25.0978 35.7786 25.4974V16.9432Z",
    fill: "#DFDFED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.334 25.5574C55.334 25.5574 55.334 30.725 48.2229 41.0604C48.2229 41.0604 55.334 37.6153 55.334 30.725V25.5574ZM12.6673 25.5574C12.6673 25.5574 12.6673 30.725 19.7784 41.0604C19.7784 41.0604 12.6673 37.6153 12.6673 30.725V25.5574Z",
    fill: "#BFBFCD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5631_3992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    fill: "white",
    transform: "matrix(-1 0 0 1 66 8.3335)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueline);
export default __webpack_public_path__ + "static/media/blueline.e83a1d2ff9c45c5bbb76e877fb11a91b.svg";
export { ForwardRef as ReactComponent };